import axios from 'axios';
import * as endpoint from '../../../endpoint';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * ダウンロードログの取得
 *
 * @param {*} apiToken APIトークン
 * @param {*} options 検索条件
 * @returns APIレスポンス
 */
const getDownloadLogs = (apiToken, options) => async dispatch => {
  consolelog('[API CALL] getDownloadLogs()');
  configureAxiosForJSON(apiToken);

  // APIエンドポイント
  const url = endpoint.API_GET_DOWNLOAD_LOGS;

  // リクエストパラメータの設定
  const { cancelToken, cancelTokenKey } = createCancelToken('getDownloadLogs');
  const params = { cancelToken, params: options };

  try {
    const res = await axios.get(url, params);
    delCancelToken(cancelTokenKey);
    return res.data?.logs;
  } catch (thrown) {
    delCancelToken(cancelTokenKey);
    if (!axios.isCancel(thrown)) {
      handleErrorResponse(
        thrown,
        dispatch,
        '',
        i18nMessages['userPrompt.message.activityLog.download.error'],
      );
    }
  }
  return null;
};

export default getDownloadLogs;
